export default () => {
    const arPopupFilters = document.querySelectorAll('.popup-filter');

    if (arPopupFilters.length === 0)
        return;

    arPopupFilters.forEach(oFilter => {
        initPopupFilter(oFilter);
    });

    function initPopupFilter(oFilter) {
        const sPopupType = oFilter.closest('.popup-pickup, .popup-store')?.dataset.popupType;
        const arPopupFilterBtns = oFilter.querySelectorAll('.popup-filter__variant');
        const oPopupFilterBottom = oFilter.querySelector('.popup-filter__bottom');
        const oPopupFilterClearBtn = oPopupFilterBottom.querySelector('.popup-filter__clear');

        if (arPopupFilterBtns.length > 0)
            arPopupFilterBtns.forEach(oFilterBtn => {
                oFilterBtn.addEventListener('click', setFilter)
            });

        oPopupFilterClearBtn?.addEventListener('click', clearFilter);

        function setFilter({ target: oTarget }) {
            const { dataset: { key: sFilterKey, value: sFilterValue } } = oTarget;

            let sBottomBlockToggleType = 'hide',
                iFilterCount = null,
                arFilteredItems = [],
                oFilterState = window.checkout[sPopupType + 'PopupFilter'] || {};

            if (!oFilterState[sFilterKey]) {
                oFilterState[sFilterKey] = [];
            }

            if (oTarget.classList.contains('selected')) {
                oFilterState[sFilterKey] = oFilterState[sFilterKey].filter(sVal => sVal !== sFilterValue);
                if (oFilterState[sFilterKey].length === 0) {
                    delete oFilterState[sFilterKey];
                }
                oTarget.classList.remove('selected');
            } else {
                oFilterState[sFilterKey].push(sFilterValue);
                oTarget.classList.add('selected');
            }

            const arActiveKeys = Object.keys(oFilterState);

            if (arActiveKeys.length > 0) {
                sBottomBlockToggleType = 'show';

                arFilteredItems = window.checkout[sPopupType + 'Points'].filter((oItem) => {
                    return arActiveKeys.every(sKey => {
                        return oFilterState[sKey].some(sValue => {
                            const mItemValue = oItem[sKey];

                            if (typeof mItemValue === 'boolean') {
                                const bFilterValue = sValue === '1' || sValue === 'true';
                                return mItemValue === bFilterValue;
                            }

                            if (Array.isArray(mItemValue)) {
                                return mItemValue.some(mItemVal => String(mItemVal) === String(sValue));
                            }

                            return String(mItemValue) === String(sValue);
                        });
                    });
                });

                iFilterCount = arFilteredItems.length;

                if (sPopupType === 'pickup')
                    window.checkout.updatePickupPopup(arFilteredItems);
                else if (sPopupType === 'shops')
                    window.checkout.updateShopsPopup(arFilteredItems);
            } else {
                clearFilter();
            }

            toggleBottomBlock(sBottomBlockToggleType, iFilterCount);
            window.checkout[sPopupType + 'PopupFilter'] = oFilterState;
        }

        function clearFilter() {
            arPopupFilterBtns.forEach(oFilterBtn => {
                oFilterBtn.classList.remove('selected');
            });

            toggleBottomBlock('hide');
            window.checkout[sPopupType + 'PopupFilter'] = {};

            if (sPopupType === 'pickup')
                window.checkout.updatePickupPopup(window.checkout.pickupPoints);
            else if (sPopupType === 'shops')
                window.checkout.updateShopsPopup(window.checkout.shopsPoints);
        }

        function toggleBottomBlock(sType, iFilterCount = 0) {
            const oFilterCountSpan = oPopupFilterBottom.querySelector('.popup-filter__count--filter');
            const oTotalCountSpan = oPopupFilterBottom.querySelector('.popup-filter__count--total');
            const iTotalCount = window.checkout[sPopupType + 'Points'].length;

            switch (sType) {
                case 'show':
                    oFilterCountSpan.innerText = iFilterCount;
                    oTotalCountSpan.innerText = iTotalCount;

                    oPopupFilterBottom.classList.add('show');
                    break;

                case 'hide':
                    oPopupFilterBottom.classList.remove('show');
                    break;

                default:
                    break;
            }
        }
    }
};